import { get } from "../../service/api";

const GetAccounts = async () => {
  try {
    const response = await get(`/admin/accounts`);
    return response;
  } catch (error) {
    console.error("Error GetAccounts:", error);
    throw error;
  }
};

export default GetAccounts;
